module.exports = __webpack_public_path__ + "img/move08.247f35d3.jpg";